import { render, staticRenderFns } from "./SfTableHeader.vue?vue&type=template&id=3d63a6b8&"
import script from "./SfTableHeader.vue?vue&type=script&lang=ts&"
export * from "./SfTableHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports